import type { CareersContent } from "./careers";

export const defaultCareersContent: CareersContent = {
  meta: {
    title: "Careers at Quintara",
    description: "Build the messaging channel a region runs on — join Quintara's founding team in Dubai and beyond.",
  },
  hero: {
    eyebrow: "Careers",
    heading: "Build the messaging channel a region runs on.",
    lede: "Quintara is building its founding team in Dubai and across our markets. If you know telecoms, AI, messaging or how businesses in the Middle East and Africa buy technology, we'd like to hear from you.",
  },
};
